import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
  } from "recharts";
  
const StreamChart = ({streamChartData}) => {
  if(!streamChartData)return <h1>No Stream Data</h1>
    return ( 
        <>  
    <h2 className="text-lg font-bold mb-2">Streaming Performance</h2>
        <ResponsiveContainer width="100%" height={200}>
          <LineChart data={streamChartData}>
            <XAxis dataKey={'key'} />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="streams"
              stroke="#aa8c16"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer> 
        <div>
          <h1 className="font-bold">Legend</h1>
          <ul className="flex flex-wrap gp-3 md:gap-8 text-gray-500 italic">
            {streamChartData.map((data) => (
              <li key={data.key} className="pb-1 pl-2 text-sm">
                *{data.key} : {data.platform}
              </li>
            ))}
          </ul>
        </div>
        </>);
}
 
export default StreamChart;